module.exports = __webpack_public_path__ + "static/media/save-money.0bf6532a.svg";